<template>
    <v-container class="mt-2">
        <h1 style="text-align:center">Latest Releases
        </h1>
        <div style="text-align:center">
        <img
          src="@/assets/equalizer.png"/>
        </div>
        <v-row>
            <v-col cols="12" class="">
                <v-slide-group show-arrows :full-width="$vuetify.breakpoint.smAndDown" center-active >
                    <v-slide-item v-for="(track, i) in tracks" :key="i">
                        <v-card class="ma-2" max-height="400" max-width="250"
                            >
                            <v-row>
                                <v-col class="pt-0 mt-0">
                                    <a :href="track.link" target="_blank">
                                        <v-img :src="track.cover" height=250 contain class="ml-1 mr-1 mb-0 mt-0 pt-0 pb-0"></v-img>
                                    </a>
                                    <v-list class="ma-0 pt-0 pb-0">
                                        <v-list-item two-line class="align-start mt-0 mb-0 pt-0">
                                            <v-list-item-content class="align-start">
                                                    <v-list-item-title style="white-space: normal!important;" class="mt-0 pt-0">
                                                        {{track.name}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
//import carousel from '@/components/slick.vue'
export default {
    name: 'Releases',
    data () {
        return {
            tracks: ''
        }
    },
    components: {
        // 'carousel': carousel

    },
    mounted () {
        this.$store.dispatch('setLoading', {variable: 'releases', value: true}).then(() => {
        this.$axios.get(this.$releases).then(response => {
        console.log(response)
        this.tracks = response.data
        }).catch((error) => console.log(error)).then(this.$store.dispatch('setLoading', {variable: 'releases', value: false}))
        })
   },

}
</script>
<style scoped>
.section-bg {
    background: url('/@assets/bg1.jpg')
}
</style>